import { REACT_APP_BLAZE } from 'env'

export const useIsBlaze = () => {
  const blazeFlag = localStorage.getItem('blaze-ci')
  const isCI = process.env.REACT_APP_ENV === 'ci'

  return REACT_APP_BLAZE === true || (isCI && !!blazeFlag)
}
